module.exports = __webpack_public_path__ + "img/title.229349cc.png";